import { useFormik } from "formik";
import { PickList } from "primereact/picklist";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
    createAPIEndpointUser,
    Endpoint,
} from "../../../Services/User/UserService";
import storage from "../../../Services/Storage";
import { toast } from "react-toastify";
import { classNames } from "primereact/utils";
import * as Fa from "react-icons/fa";
import Loader from "../../../Components/Loader";

const UserDetails = () => {
    const [emplysuggestion, setemplysuggestion] = useState([]);
    const [employee, setemployee] = useState([]);
    // const [usergrpsuggestion, setUsergrpsuggestion] = useState([]);
    // const [usergrp, setUsergrp] = useState([]);
    // const [distributor, setDistributor] = useState();
    const [olduser, setOlduser] = useState(false);
    const [loader, setLoader] = useState(false);
    // const [viewonlyUsergrp, setViewonlyUsergrp] = useState([]);
    // const [viewonlyUsergroupId, setViewonlyUsergroupId] = useState("");
    const [editAllData, setEditAllData] = useState([]);
    const [getDistributor, setGetDistributor] = useState();
    const [onlyUserId, setOnlyUserId] = useState("");
    const [employeeName, setEmployeeName] = useState("");
    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);

    const auth = storage.getLocal("user");
    const [searchParams] = useSearchParams();
    let emp_id = searchParams.get("userid");
    //
    const nav = useNavigate();
    const initialValues = {
        userid: "",
        employee: "",
        status: "",
        lastlogin: "",
        lastlogout: "",
        nologin: "",
        distributor: getDistributor,
        prefixuserid: "",
        source:source,
        target: []
    };

    useEffect(() => {
        if (emp_id != null) {
            setOlduser(true);
            editDataApi(emp_id);
            renderAllEmployeeData();
            renderDistributor();
        } else {
            renderAllEmployeeData();
            renderAllUserGrpData();
            renderDistributor();
        }
    }, []);

    // const editDataApi = (emp_id) => {
    //     setLoader(true);
    //     createAPIEndpointUser()
    //         .get(
    //             `${Endpoint.GetAllUserGrpDataById}?UserId=${emp_id}&CompId=${auth.CompId}`
    //         )
    //         .then((res) => {
    //             setSource(res.data.Data);
    //         })
    //         .catch((error) => {
    //             toast.error(error.message, {
    //                 position: toast.POSITION.TOP_CENTER,
    //                 pauseOnFocusLoss: false,
    //                 closeButton: false,
    //                 autoClose: 2000,
    //             });
    //         });

    //     createAPIEndpointUser()
    //         .get(`${Endpoint.ViewUserManagementData}?UserId=${emp_id}`)
    //         .then((res) => {
    //             setEditAllData(res?.data?.Data[0]);
    //             setOnlyUserId(res?.data?.Data[0]?.USER_ID);
    //             setEmployeeName(res?.data?.Data[0]?.EMPLOYEE);
    //         })
    //         .catch((error) => {
    //             toast.error(error.message, {
    //                 position: toast.POSITION.TOP_CENTER,
    //                 pauseOnFocusLoss: false,
    //                 closeButton: false,
    //                 autoClose: 2000,
    //             });
    //         });

    //     createAPIEndpointUser()
    //         .get(
    //             `${Endpoint.GetViewOnlyUserMappedData}?UserId=${emp_id}&strCompId=${auth.CompId}`
    //         )
    //         .then((res) => {
    //             setTarget(res?.data?.Data);
    //         })
    //         .catch((error) => {
    //             toast.error(error.message, {
    //                 position: toast.POSITION.TOP_CENTER,
    //                 pauseOnFocusLoss: false,
    //                 closeButton: false,
    //                 autoClose: 2000,
    //             });
    //         });
    //         setLoader(false);
    // };
    const editDataApi = async (emp_id) => {
        try {
            setLoader(true);

            const [userDataRes, userGrpRes, mappedRes] = await Promise.all([
                createAPIEndpointUser().get(`${Endpoint.ViewUserManagementData}?UserId=${emp_id}`),
                createAPIEndpointUser().get(`${Endpoint.GetAllUserGrpDataById}?UserId=${emp_id}&CompId=${auth.CompId}`),
                createAPIEndpointUser().get(`${Endpoint.GetViewOnlyUserMappedData}?UserId=${emp_id}&strCompId=${auth.CompId}`)
            ]);

            const userData = userDataRes?.data?.Data[0];
            setEditAllData(userData);
            setOnlyUserId(userData.USER_ID);
            setEmployeeName(userData.EMPLOYEE);
            setSource(userGrpRes?.data?.Data);
            setTarget(mappedRes?.data?.Data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoader(false);
        }
    };


    const renderAllEmployeeData = () => {
        createAPIEndpointUser()
            .get(`${Endpoint.GetEmployeeList}?CompId=${auth.CompId}`)
            .then((res) => {
                setemplysuggestion(res.data.Data);
            })
            .catch((error) => {
                toast.error(error.message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            });
    };

    const renderAllUserGrpData = () => {
        createAPIEndpointUser()
            .get(`${Endpoint.GetAllUserGrpData}?CompId=${auth.CompId}`)
            .then((res) => {
                setSource(res.data.Data);
                setTarget([]);
            })
            .catch((error) => {
                toast.error(error.message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            });
    };

    const renderDistributor = () => {
        createAPIEndpointUser()
            .get(`${Endpoint.GetAllDistributor}?CompId=${auth.CompId}`)
            .then((res) => {
                setGetDistributor(res.data.Data[0].COMP_NAME);
            })
            .catch((error) => {
                toast.error(error.message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            });
    };

    const employeeTemplate = (employee) => {
        return (
            <>
                {employee.EMP_CODE} - {employee.NAME}
            </>
        );
    };

    const searchEmployee = (e) => {
        setTimeout(() => {
            let _filteredemployee;
            if (!e.query.trim().length) {
                _filteredemployee = [...emplysuggestion];
            } else {
                _filteredemployee = emplysuggestion.filter((employee) => {
                    return (
                        employee.EMP_CODE.toLowerCase().includes(e.query.toLowerCase()) ||
            employee.NAME.toLowerCase().includes(e.query.toLowerCase())
                    );
                });
            }

            setemployee(_filteredemployee);
        }, 250);
    };


    const status = [
        {
            id: "Active",
            value: "Active",
        },
        {
            id: "Inactive",
            value: "Inactive",
        },
    ];

    const formik = useFormik({
        initialValues: initialValues,
        validate: (data) => {
            let errors = {};

            if (!data.employee) {
                errors.employee = "Employee is required";
            }
            if (!data.userid) {
                errors.userid = "User Id is required";
            }
            if(data.target.length==0){
                errors.target = "User Group is required";
            }
            return errors;
        },
        enableReinitialize: true,
        onSubmit: (data) => {
            submittingUserDetils(data);
            formik.resetForm();
        },
    });

    const submittingUserDetils = (data) => {
        let listofgrp = data.target.map((item) => {
            return { pvcGRP_ID: item.MASK_GR_ID };
        });
        let editstatus = "";
        if (olduser) {
            if (editAllData.MASK_STATUS == "Y" && data.status === "INACTIVE") {
                editstatus = "INACTIVE";
            } else if (editAllData.MASK_STATUS == "N" && data.status === "ACTIVE") {
                editstatus = "ACTIVE";
            } else if (editAllData.MASK_STATUS == "Y" && data.status === "ACTIVE") {
                editstatus = "";
            } else if (editAllData.MASK_STATUS == "N" && data.status === "INACTIVE") {
                editstatus = "";
            }
        }
        const payload = {
            pvcUSER_ID: auth.UserId,
            pvcCI_CODE: auth.CICode,
            pvcCOMP_ID: auth.CompId,
            pvcNEW_USER_ID: auth.CICode + "_" + data.userid,
            pvcUSER_PASSWORD: "",
            pvcDEFINED_BY: "E",
            pvcSTATUS: data.status === "Active" ? "Y" : "N",
            pvcISActive: "",
            pvcEMP_ID: data.employee.MASK_EMP_ID,
            iukey: "1",
            lstUserGrp: listofgrp,
        };

        const editpayload = {
            pvcUSER_ID: auth.UserId,
            pvcCI_CODE: auth.CICode,
            pvcCOMP_ID: auth.CompId,
            pvcNEW_USER_ID: editAllData.USER_ID,
            pvcUSER_PASSWORD: editAllData.MASK_USER_PASSWORD,
            pvcDEFINED_BY: "E",
            pvcSTATUS: data.status === "Active" ? "Y" : "N",
            pvcISActive: editstatus,
            pvcEMP_ID:
        editAllData.EMPLOYEE == data.employee
            ? editAllData.MASK_EMP_ID
            : data.employee.MASK_EMP_ID,
            iukey: "2",
            lstUserGrp: listofgrp,
        };
        // console.log(editpayload);
        // console.log(payload);
        // return;

        createAPIEndpointUser()
            .post(
                `${Endpoint.UserDataSave}`,
                JSON.stringify(olduser ? editpayload : payload),
                {
                    headers: { "Content-Type": "application/json" },
                }
            )
            .then((response) => {
                toast.success(response.data.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 4000,
                });
                nav("/usermanagement/user");
            })
            .catch((error) => {
                toast.error(error.message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            });
    };

    const isFormFieldInvalid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldInvalid(name) ? (
            <small className="p-error">{formik.errors[name]}</small>
        ) : (
            <small className="p-error">&nbsp;</small>
        );
    };

    console.log("formik",formik);
    console.log("editAllData",editAllData);

    useEffect(()=>{
        formik.setValues({
            userid: onlyUserId,
            employee:employeeName,
            status :
      editAllData.MASK_STATUS == "Y" ? "Active" : "Inactive",
            lastlogin : editAllData.MASK_LAST_LOGIN,
            lastlogout : editAllData.MASK_LAST_LOGOUT,
            nologin : editAllData.MASK_LOGIN_COUNT,
            distributor : getDistributor,
            prefixuserid : "",
            source:source,
            target:target
        });
    },[editAllData]);

    const itemTemplate = (item) => {
        return (
            <div>
                <div>{item.USER_GROUP}</div>
                <small>{item.GR_CODE}</small>
            </div>
        );
    };
    const { setFieldValue } = formik;
  
    const onChange = (e) => {
        setFieldValue("source", e.source);
        setFieldValue("target", e.target);
    };

    return (
        <div className="col-12 pt-0 pb-4">
            <div className="">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mx-1">
                                <li className="breadcrumb-item">
                                    <Link to="/usermanagement/user">User Management</Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                  Details
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end">
                            <Link to="/usermanagement/user">
                                <button type="submit" className="btn btn-primary">
                                    <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                  Records
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                {loader?<Loader/>:null}
                <section>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-lg-5 col-md-12 col-sm-12">
                                <div className="sales-box">
                                    <div className="d-block mb-3">
                                        <label className="form-label">
                      Distributor <span className="mandatory">*</span>
                                        </label>
                                        <InputText
                                            className="form-control"
                                            type="text"
                                            disabled
                                            values={formik.values.distributor}
                                            defaultValue={formik.initialValues.distributor}
                                        />
                                    </div>
                                    {olduser ? (
                                        <div className="d-block mb-3">
                                            <label className="form-label">
                        User ID <span className="mandatory">*</span>
                                            </label>
                                            <InputText
                                                id="uid"
                                                name="uid"
                                                value={onlyUserId}
                                                disabled
                                            />
                                        </div>
                                    ) : (
                                        <div className="d-block">
                                            <label className="form-label d-block">
                        User ID <span className="mandatory">*</span>
                                            </label>
                                            <InputText
                                                style={{ width: "49%" }}
                                                className="form-control d-inline me-1"
                                                value={auth.CICode + "_"}
                                                disabled
                                            />
                                            <InputText
                                                id="userid"
                                                name="userid"
                                                style={{ width: "49%" }}
                                                value={formik.values.userid}
                                                onChange={(e) => {
                                                    if (e.target.value.trim().length < 3) {
                                                        formik.setFieldValue("userid", e.target.value);
                                                    }
                                                }}
                                                className={classNames(
                                                    { "p-invalid": isFormFieldInvalid("userid") },
                                                    "form-control d-inline"
                                                )}
                                                disabled={olduser}
                                            />
                                            {getFormErrorMessage("userid")}
                                        </div>
                                    )}

                                    <div className="d-block">
                                        <label className="form-label">
                      Employee <span className="mandatory">*</span>
                                        </label>
                                        <AutoComplete
                                            field="NAME"
                                            name="employee"
                                            value={formik.values.employee}
                                            suggestions={employee}
                                            completeMethod={searchEmployee}
                                            onChange={(e) => {
                                                formik.setFieldValue("employee", e.value);
                                            }}
                                            dropdown={true}
                                            itemTemplate={employeeTemplate}
                                            emptyMessage="No Employee found."
                                            showEmptyMessage
                                            className={classNames({
                                                "p-invalid": isFormFieldInvalid("employee"),
                                            })}
                                        />
                                        {getFormErrorMessage("employee")}
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <div className="d-block mb-3">
                                                <label className="form-label">
                          Last Login <span className="mandatory">*</span>
                                                </label>
                                                <InputText
                                                    id="lastlogin"
                                                    name="lastlogin"
                                                    className="form-control"
                                                    value={formik.values.lastlogin}
                                                    onChange={(e) => {
                                                        formik.setFieldValue("title", e.target.value);
                                                    }}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <div className="d-block mb-3">
                                                <label className="form-label">
                          Last Logout <span className="mandatory">*</span>
                                                </label>
                                                <InputText
                                                    id="lastlogout"
                                                    name="lastlogout"
                                                    className="form-control"
                                                    value={formik.values.lastlogout}
                                                    onChange={(e) => {
                                                        formik.setFieldValue("lastlogout", e.target.value);
                                                    }}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <div className="d-block mb-3">
                                                <label className="form-label">
                          Number of Login <span className="mandatory">*</span>
                                                </label>
                                                <InputText
                                                    id="nologin"
                                                    name="nologin"
                                                    className="form-control"
                                                    value={formik.values.nologin}
                                                    onChange={(e) => {
                                                        formik.setFieldValue("nologin", e.target.value);
                                                    }}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <div className="d-block mb-3">
                                                <div className="mt-0">
                                                    <label className="form-label d-block">
                            Status <span className="mandatory">*</span>
                                                    </label>
                                                    {status.map((btn, i) => {
                                                        return (
                                                            <div key={i} className="d-inline-flex pe-2">
                                                                <RadioButton
                                                                    {...btn}
                                                                    checked={formik.values.status === btn.value}
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue("status", e.value);
                                                                    }}
                                                                />
                                                                <label htmlFor={btn.inputId} className="ps-2">
                                                                    {btn.value}
                                                                </label>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="text-end">
                                            {/* <button type="submit" className="btn btn-cancel-red me-3">
                        Cancel
                      </button> */}
                                            <button type="submit" className="btn btn-primary">
                        Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-12 col-sm-12">
                                <div className="PickListPanel sales-box">
                                    <PickList
                                        dataKey="MASK_GR_ID"
                                        source={formik.values.source}
                                        target={formik.values.target}
                                        breakpoint="768px"
                                        itemTemplate={itemTemplate}
                                        onChange={onChange}
                                        filter
                                        filterBy="USER_GROUP"
                                        sourceHeader="Available Groups"
                                        targetHeader="Member of Groups"
                                        sourceStyle={{ height: "24rem" }}
                                        targetStyle={{ height: "24rem" }}
                                        className={classNames({
                                            "p-invalid": isFormFieldInvalid("target"),
                                        })}
                                    />
                                    {getFormErrorMessage("target")}
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </div>
    );
};

export default UserDetails;
